import * as React from 'react';
import { Route, Routes } from 'react-router-dom';

// Pages
import HomePage from './Pages/HomePage';
import CompetitorsPage from './Pages/CompetitorsPage';
import RaceTimerDataPage from './Pages/RaceTimerData';
import SeriesPage from './Pages/SeriesPage'; 
import RaceCompetitorPage from './Pages/RaceCompetitorPage'; 
import DecoderPage from './Pages/DecoderPage';
import CheckpointsPage from './Pages/CheckpointsPage';
import AddCompetitorPage from './Pages/AddCompetitorPage';
import ManageSeriesPage from './Pages/ManageSeriesPage';
import LoginPage from './Pages/LoginPage';
import RaceResultsPage from './Pages/RaceResultsPage';
import EditEventPage from './Pages/EditEventPage';
import RaceListPage from './Pages/RaceListPage';
import EditRacePage from './Pages/EditRacePage';
import ImportRaceDataPage from './Pages/ImportRaceDataPage';
import ImportCompetitorsPage from './Pages/ImportCompetitorsPage';
import ImportLogsPage from './Pages/ImportLogsPage';


export class App extends React.Component<any,any>
{
	constructor(props:any)
	{
		super(props);
	}

	render() {
		return (
			<div className="d-flex flex-column flex-fill">
			
				<Routes>
					<Route path="/" element={<HomePage />} />
					<Route path="/Series/Add" element={<ManageSeriesPage />} />
					<Route path="/Series/Manage/:seriesid" element={<ManageSeriesPage />} />
					<Route path="/Series/:seriesid" element={<SeriesPage />} />
					<Route path="/Series/:seriesid/Events/Add" element={<EditEventPage />} />
					<Route path="/Series/:seriesid/Events/Edit/:eventid" element={<EditEventPage />} />
					<Route path="/Event/:eventid/" element={<RaceListPage />} />
					<Route path="/Event/:eventid/Races/Add/" element={<EditRacePage />} />
					<Route path="/Races/Edit/:raceid" element={<EditRacePage />} />
					<Route path="/ImportAccess/:raceid" element={<ImportRaceDataPage />} />
					<Route path="/ImportLog/:raceid" element={<ImportLogsPage />} />
					<Route path="/ImportCompetitors/:raceid" element={<ImportCompetitorsPage />} />
					<Route path="/Race/:raceid" element={<RaceResultsPage />} />
					<Route path="/Race/:raceid/addCompetitor" element={<AddCompetitorPage />} />
					<Route path="/Decoder/:raceid" element={<DecoderPage />} />
										<Route path="/Checkpoints/:raceid" element={<CheckpointsPage />} />
					<Route path="/Race/:raceid/Competitors" element={<RaceCompetitorPage />} />
					<Route path="/Race/:raceid/RaceTimer" element={<RaceTimerDataPage />} />
					<Route path="/login" element={<LoginPage />} />
					<Route path="/Series/:seriesid/competitors" element={<CompetitorsPage />} />
				</Routes>

			</div>

		);
	}
}